export default "__VITE_ASSET__QTq7VAvC__"